var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipPeanut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM16.27 11C16.12 11.1 15.99 11.21 15.87 11.33H15.86C15.32 11.88 14.99 12.62 14.97 13.44C15.07 13.78 15.13 14.14 15.14 14.52C15.14 14.53 15.15 14.55 15.15 14.56C15.24 17.56 12.55 19.94 9.46 19.33C7.63 18.97 6.15 17.49 5.79 15.66C5.37 13.49 6.44 11.52 8.15 10.58C8.3 10.52 8.45 10.45 8.59 10.36H8.6C9.31 9.94 9.83 9.25 10.03 8.42C10.02 8.38 10.02 8.34 10.02 8.3C10.02 8.04 10.05 7.8 10.1 7.55C10.5 5.58 12.49 4.16 14.66 4.69C16.05 5.03 17.15 6.22 17.39 7.64C17.62 8.97 17.15 10.19 16.27 11Z",
    fill: "#973C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38 14.02C7.66167 14.02 7.89 13.7917 7.89 13.51C7.89 13.2283 7.66167 13 7.38 13C7.09833 13 6.87 13.2283 6.87 13.51C6.87 13.7917 7.09833 14.02 7.38 14.02Z",
    fill: "#973C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34 12.99C8.47255 12.99 8.58 12.8825 8.58 12.75C8.58 12.6175 8.47255 12.51 8.34 12.51C8.20745 12.51 8.1 12.6175 8.1 12.75C8.1 12.8825 8.20745 12.99 8.34 12.99Z",
    fill: "#973C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27 15.62C7.61794 15.62 7.9 15.3379 7.9 14.99C7.9 14.6421 7.61794 14.36 7.27 14.36C6.92206 14.36 6.64 14.6421 6.64 14.99C6.64 15.3379 6.92206 15.62 7.27 15.62Z",
    fill: "#973C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43 14.92C8.67853 14.92 8.88 14.7185 8.88 14.47C8.88 14.2215 8.67853 14.02 8.43 14.02C8.18147 14.02 7.98 14.2215 7.98 14.47C7.98 14.7185 8.18147 14.92 8.43 14.92Z",
    fill: "#973C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 9.56C16.7609 9.56 16.94 9.38091 16.94 9.16C16.94 8.93909 16.7609 8.76 16.54 8.76C16.3191 8.76 16.14 8.93909 16.14 9.16C16.14 9.38091 16.3191 9.56 16.54 9.56Z",
    fill: "#973C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.81 8.68C16.9702 8.68 17.1 8.55016 17.1 8.39C17.1 8.22984 16.9702 8.1 16.81 8.1C16.6498 8.1 16.52 8.22984 16.52 8.39C16.52 8.55016 16.6498 8.68 16.81 8.68Z",
    fill: "#973C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipPeanut);
export default __webpack_public_path__ + "static/media/ic-chip-peanut.c5d8d6053270561737aa94316545209b.svg";
export { ForwardRef as ReactComponent };